import axios from "axios";
import { getUserinfo } from "@utils/localStorage";

/** Token helper for cloned MiniGame module */
export function getCookie(name = "token") {
  if (name === "token") {
    const user = getUserinfo();
    return user?.access_token || user?.token;
  }
  return undefined;
}

function normalizeError(err) {
  const message =
    err?.response?.data?.errorMessage ||
    err?.response?.data?.message ||
    err?.message ||
    "Request failed";
  return { success: false, message, data: null, error: err };
}

export async function getDataApi(url, params) {
  try {
    const res = await axios.get(url, { params });
    const payload = res?.data ?? {};
    return typeof payload === "object" ? payload : { success: true, data: payload };
  } catch (err) {
    return normalizeError(err);
  }
}

export async function postDataApi(url, body) {
  try {
    const res = await axios.post(url, body);  
    const payload = res?.data ?? {};
    return typeof payload === "object" ? payload : { success: true, data: payload };
  } catch (err) {
    return normalizeError(err);
  }
}

